import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Format requis par OAuth2PasswordRequestForm de FastAPI (x-www-form-urlencoded)
    const formData = new URLSearchParams();
    formData.append('username', username);
    formData.append('password', password);

    const res = await fetch("/api/token", { 
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formData
    });

    if (res.ok) {
      const data = await res.json();
      login(data.access_token);
      navigate("/"); // Redirection vers accueil
    } else {
      alert("Erreur de connexion");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "100px" }}>
      <form onSubmit={handleSubmit} style={{ padding: "40px", border: "1px solid #ccc" }}>
        <h2>Connexion</h2>
        <div>
          <label>Utilisateur:</label><br/>
          <input type="text" value={username} onChange={e => setUsername(e.target.value)} />
        </div>
        <div style={{marginTop: "10px"}}>
          <label>Mot de passe:</label><br/>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        <button type="submit" style={{marginTop: "20px"}}>Se connecter</button>
      </form>
    </div>
  );
}

export default LoginPage;